export const Visibility = {
	private: "private",
	public: "public"
}
